import { injectedUserOrgApi } from './injectedUserOrgApi';

export const enhancedUserOrgApi = injectedUserOrgApi.enhanceEndpoints({
    addTagTypes: [
        'GetProject',
        'GetApiProjectTag',
        'GetApiRequests',
        'GetApiProjectResource',
        'GetApiProjectByProjectShortNameUsers',
        'GetApiUserInfo',
        'GetApiUserInfoWithHeaders',
        'GetApiProjectResourceAssignment',
        'GetApiUserPreferences',
        'GetApiUserPreferencesParsed',
        'GetApiOtherStatistics',
        'GetApiRequestsSentRequests',
    ],
    endpoints: {
        getApiOtherStatistics: {
            providesTags: ['GetApiOtherStatistics'],
        },
        getProject: {
            providesTags: ['GetProject'],
        },
        getApiProjectTag: {
            providesTags: ['GetApiProjectTag'],
        },
        getApiRequests: {
            providesTags: ['GetApiRequests'],
        },
        getApiRequestsSentRequests: {
            providesTags: ['GetApiRequestsSentRequests'],
        },
        getApiProjectResource: {
            providesTags: ['GetApiProjectResource'],
        },

        getApiUserInfo: {
            providesTags: ['GetApiUserInfo'],
        },
        getApiUserInfoWithHeaders: {
            providesTags: ['GetApiUserInfoWithHeaders'],
        },
        getApiProjectByProjectShortNameUsers: {
            providesTags: ['GetApiProjectByProjectShortNameUsers'],
        },
        getApiProjectResourceAssignment: {
            providesTags: ['GetApiProjectResourceAssignment'],
        },
        getApiUserPreferences: {
            providesTags: ['GetApiUserPreferences'],
        },
        getApiUserPreferencesParsed: {
            providesTags: ['GetApiUserPreferencesParsed'],
        },
        postApiProject: {
            invalidatesTags: ['GetProject', 'GetApiUserInfo', 'GetApiUserInfoWithHeaders', 'GetApiOtherStatistics'],
        },
        putApiProject: {
            invalidatesTags: ['GetProject', 'GetApiOtherStatistics'],
        },
        deleteApiProjectByProjectShortName: {
            invalidatesTags: ['GetProject', 'GetApiOtherStatistics'],
        },
        putApiProjectByProjectShortNameProjectResourceAndProjectResourceName: {
            invalidatesTags: ['GetProject', 'GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        deleteApiProjectByProjectShortNameProjectResourceAndProjectResourceName: {
            invalidatesTags: ['GetProject', 'GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        deleteApiProjectTagById: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag', 'GetApiOtherStatistics'],
        },
        putApiProjectByProjectShortNameProjectTagAndProjectTagId: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag'],
        },
        postApiProjectTag: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag'],
        },
        putApiProjectTag: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag'],
        },
        putApiRequestsByRequestIdReject: {
            invalidatesTags: ['GetProject', 'GetApiProjectByProjectShortNameUsers', 'GetApiRequests'],
        },
        putApiRequestsByRequestIdAccept: {
            invalidatesTags: ['GetProject', 'GetApiProjectByProjectShortNameUsers', 'GetApiRequests'],
        },

        postApiProjectResource: {
            invalidatesTags: ['GetProject', 'GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        deleteApiProjectByProjectShortNameProjectTagAndProjectTagId: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag'],
        },
        postApiRequests: {
            invalidatesTags: ['GetApiProjectTag', 'GetApiRequestsSentRequests'],
        },
        postApiProjectResourceAssignment: {
            invalidatesTags: ['GetApiProjectResourceAssignment'],
        },
        putApiProjectResourceAssignment: {
            invalidatesTags: ['GetApiProjectResourceAssignment'],
        },
        deleteApiProjectResourceAssignmentById: {
            invalidatesTags: ['GetApiProjectResourceAssignment'],
        },
        putApiProjectResource: {
            invalidatesTags: ['GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        deleteApiProjectResourceById: {
            invalidatesTags: ['GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        putApiUserPreferences: {
            invalidatesTags: ['GetApiUserPreferences', 'GetApiUserPreferencesParsed'],
        },
    },
});

export const {
    useGetVersionQuery,
    useWorkerDataQuery,
    useGetApiOtherCountryQuery,
    useGetApiOtherStatisticsQuery,
    useGetApiProjectByProjectShortNameUsersQuery,
    useGetProjectQuery,
    usePostApiProjectMutation,
    usePutApiProjectMutation,
    useDeleteApiProjectByProjectShortNameMutation,
    usePutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameMutation,
    useDeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameMutation,
    usePutApiProjectByProjectShortNameProjectTagAndProjectTagIdMutation,
    useDeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdMutation,
    useTemplatesInfoQuery,
    useExtendedProjectInfoQuery,
    useGetApiProjectResourceAssignmentQuery,
    usePostApiProjectResourceAssignmentMutation,
    usePutApiProjectResourceAssignmentMutation,
    useGetProjectResourceAssignmentQuery,
    useDeleteApiProjectResourceAssignmentByIdMutation,
    useGetApiProjectResourceQuery,
    usePostApiProjectResourceMutation,
    usePutApiProjectResourceMutation,
    useGetProjectResourceQuery,
    useDeleteApiProjectResourceByIdMutation,
    useGetApiProjectTagQuery,
    usePostApiProjectTagMutation,
    usePutApiProjectTagMutation,
    useGetProjectTagQuery,
    useDeleteApiProjectTagByIdMutation,
    usePostApiPublicHandleByActionLinkMutation,
    useGetApiPublicRequestInfoByRequestIdQuery,
    useGetApiRequestsQuery,
    usePostApiRequestsMutation,
    useGetApiRequestsSentRequestsQuery,
    usePutApiRequestsByRequestIdAcceptMutation,
    usePutApiRequestsByRequestIdRejectMutation,
    useSyncDetailsQuery,
    useProjectsInfoQuery,
    useGetApiUserPreferencesQuery,
    usePutApiUserPreferencesMutation,
    useGetApiUserInfoQuery,
    useGetApiUserInfoExtendedQuery,
    useGetApiUserInfoWithHeadersQuery,
    useGetApiUserPreferencesParsedQuery,
    useValidRolesQuery,
} = enhancedUserOrgApi;
